<template>
  <div class="layout--full-page">
    <h4 class="mt-2 pr-2 pl-2" v-if="$route.meta.pageTitle" v-text="$t($route.meta.pageTitle)"></h4>
    <vs-divider class="mt-2 mb-2" v-if="$route.meta.pageTitle"></vs-divider>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    extension: {
      get () {
        return this.$store.getters.extension
      },
      set (value) {
        this.$store.dispatch('setExtension', value)
      }
    }
  },
  mounted () {

    document.body.classList.remove('theme-dark')
    document.body.classList.add('window-popup')

    if (this.extension === null) {
      this.extension = this.$store.getters.userInfo.extension
    }
  }
}
</script>

<style scoped>

</style>
